var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-row" }, [
    _c("div", { staticClass: "form-group col-12" }, [
      _c("p", { staticClass: "font-weight-bold" }, [_vm._v("Select light")]),
      _vm._v(" "),
      _c("div", { staticClass: "models-wrapper" }, [
        _c("div", { staticClass: "mr-3" }, [
          _c("div", [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                on: {
                  click: function($event) {
                    return _vm.selectLight("point")
                  }
                }
              },
              [_vm._v("\n              Point light\n            ")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mr-3" }, [
          _c("div", [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                on: {
                  click: function($event) {
                    return _vm.selectLight("spot")
                  }
                }
              },
              [_vm._v("\n              Spot light\n            ")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mr-3" }, [
          _c("div", [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                on: {
                  click: function($event) {
                    return _vm.selectLight("directional")
                  }
                }
              },
              [_vm._v("\n              Directional light\n            ")]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5893da07", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5893da07","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/timeline-components/light.vue
// module id = null
// module chunks = 